import React, { useState } from "react";
import CommentInput from "./CommentInput";

export default function NewCommentForm({ handleSubmit, clientView }) {
  const [comment, setComment] = useState("");
  const [clientVisible, setClientVisible] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit({ body: comment, client_visible: clientVisible })
      .then(() => setComment(""))
      .then(() => setClientVisible(false));
  };

  return (
    <form onSubmit={onSubmit} className="form-inline">
      <CommentInput
        comment={comment}
        setComment={setComment}
        clientVisible={clientVisible}
        setClientVisible={setClientVisible}
        clientView={clientView}
      />
    </form>
  );
}
